module.exports = __webpack_public_path__ + "img/update-icon-01.ff402e62.svg";